import isPositiveInteger from '~/utils/isPositiveInteger'

const findPageNumber = (slug: any) => {
  let pageNumber = 0
  if (slug.includes('page')) {
    pageNumber = slug.find((item: any) => isPositiveInteger(item))
  }
  return Number(pageNumber)
}

export const doPagination = (context: any) => {
  const totalPerPage = 20

  if (!context.params || !context.params?.slug?.includes('page')) {
    return {
      offset: 0,
      limit: totalPerPage,
      nextPageNumber: 2,
      totalPerPage,
    }
  }

  // Does the slug contain the word page?
  const pageNumber = findPageNumber(context.params.slug)

  // 0 = 0
  // (2 - 1) * 12 = 12
  // (3 - 1) * 12 = 24
  // (4 - 1) * 12 = 36
  const offset = context.params.slug[2] ? (pageNumber - 1) * totalPerPage : 0

  // 0 = 12
  // 1 = (1 + 1) * 12 = 24
  // 2 = (2 + 1) * 12 = 36
  const limit = context.params.slug[2]
    ? pageNumber * totalPerPage
    : totalPerPage

  // nextPageNumber is passed as a queryParam in the data in order to be used
  // in the SSG button for loading more with a traditional /page/2 link
  const nextPageNumber = pageNumber === 0 ? 2 : pageNumber + 1

  return {
    offset,
    limit,
    nextPageNumber,
    totalPerPage,
  }
}

/**
 * New pagination function that uses the page query param instead of the slug
 * the above will become deprecated after the transition to the rewritten URLs
 */

export type IPaginationContext = {
  params: {
    lang?: string
    page?: string
    category?: string
  }
}

export const getPagination = (context: IPaginationContext) => {
  const totalPerPage = 20

  if (!context.params.page) {
    return {
      offset: 0,
      limit: totalPerPage,
      nextPageNumber: 2,
      totalPerPage,
      pageNumber: 1,
    }
  }

  const pageNumber = Number(context.params.page)

  const offset = pageNumber > 1 ? (pageNumber - 1) * totalPerPage : 0

  const limit = pageNumber * totalPerPage

  const nextPageNumber = pageNumber + 1

  return {
    offset,
    limit,
    nextPageNumber,
    totalPerPage,
    pageNumber,
  }
}
